// ModeratorPanelPage.tsx (updated)
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { ZegoExpressEngine } from "zego-express-engine-webrtc";
import  ModeratorTalentStreamViewer from "./TalentLiveStreamForModerator";
import { zegoInit } from "./../../../utils/zegoInit";
import { useCurrentTalentProfile } from "../../../hooks";
import ModeratorPanel from "./ModeratorPanelLayout"; // ⬅️ use the new read-only layout


export function ModeratorPanelPage() {
  const { channel_name } = useParams();
  const navigate = useNavigate();

  // Keep a Zego instance so moderator can VIEW the stream (no controls exposed).
  const [zg, setZg] = useState<ZegoExpressEngine | null>(null);

  const [params] = useSearchParams();
  const userId = params.get("userId");
  // bookingId is still read by the layout and child tools via URL
  const bookingId = params.get("bookingId");

  // Load current profile if needed for child tools (no stream control granted here)
  const { currentProfile } = useCurrentTalentProfile();

  useEffect(() => {
    // Initialize Zego engine strictly for playback/viewing in moderator context
    try {
      const zego = zegoInit();
      setZg(zego);
      console.log("[Zego] Engine initialized (moderator view)", zego);
    } catch (error) {
      console.error("[Zego] Init failed (moderator view):", error);
    }
  }, [channel_name, userId]);

  const handleCallEnd = () => {
    navigate("/");
  };

  if (!userId) return null;

  return (
    <ModeratorPanel>
      <ModeratorTalentStreamViewer
        zg={zg}
        displayName="Live Stream"
        userId={"moderator"}
        videoId={channel_name ?? ""}
        username={"moderator"}
        bookingId={bookingId ?? ""}
      />
    </ModeratorPanel>
  );
}

export default ModeratorPanelPage;
